import React, { useEffect } from 'react';
import { Outlet } from 'react-router-dom';
import { Box, makeStyles } from '@material-ui/core';
import 'react-toastify/dist/ReactToastify.css';
import MenuControl from './MenuControl';
import { ButtonShowMenuTracking, ButtonHideMenuTracking } from 'src/app/components/button/ButtonMenu';
import {
  getListVehicleTrackingById,
  getListVehicleTrackingByUserId,
} from 'src/features/vehicleSlice';
import { useDispatch, useSelector } from 'react-redux';
import useVehicleTracking from 'src/app/hooks/useVehicleTracking';

const MonitorView = () => {
  const classes = useStyles();
  const dispatch = useDispatch();

  const {isAdmin, isAgency, isUser, userId, agencyId, adminId} = useSelector(state => state.authSlice);
  const trackingId = adminId ?? agencyId;

  const deviceSerial = useSelector(state => state.videoSlice.deviceSerial);

  const fetchData = () => {
    if (trackingId) {
      dispatch(
        getListVehicleTrackingById({
          id: trackingId,
          data: {
            device_type_id: [1,7],
          }
        })
      );
    }
  };

  const fetchDataByUserId = () => {
    dispatch(
      getListVehicleTrackingByUserId({
        id: userId,
        data: {
          device_type_id: [1, 7],
          agency_id: agencyId || undefined
        }
      })
    );
  };

  useEffect(() => {
    if (isUser) {
      fetchDataByUserId();
      return;
    }
    fetchData();
  }, [isAdmin, isAgency, isUser, dispatch]);

  useVehicleTracking();

  const [showMenu, setShowMenu] = React.useState(true);

  const handleToggleMenu = (show) => {
    setShowMenu(show);
    const url = new URL(window.location);
    url.searchParams.set('show_menu', show);
    window.history.pushState({}, '', url);
  };

  return (
    <div className={classes.root}>
      <ButtonShowMenuTracking setShowMenu={handleToggleMenu} showMenu={showMenu} type={'camera_streaming'}/>
      <ButtonHideMenuTracking showMenu={showMenu} setShowMenu={handleToggleMenu} type={'camera_streaming'}/>
      
      <MenuControl
        showMenu={showMenu}
        setShowMenu={setShowMenu}
        deviceSerial={deviceSerial}
        fetchData={fetchData}
        fetchDataByUserId={fetchDataByUserId}
      />

      <Box
        style={{
          flex: 1,
          overflowY: 'auto',
          overflowX: 'hidden',
          position: 'relative',
          transition: 'all 0.3s ease'
        }}
      >
        <Outlet />
      </Box>
    </div>
  );
};

const useStyles = makeStyles(theme => ({
  root: {
    backgroundColor: theme.palette.background.dark,
    display: 'flex',
    overflow: 'hidden',
    position: 'relative',
    height: 'calc(100vh - 66px)'
  }
}));

export default React.memo(MonitorView);
